import { 
  SubTab1, 
  SubTab2,
  SubTab3
} from './components';

export const tabs = () => {
  return [
    {
      label: `1.1 Βασικά Στοιχεία Επιχείρησης`,
      id: '1_1',
      Component: SubTab1,
    },
    {
      label: `1.2 Στοιχεία Εταίρων/Μετόχων Φορέα`,
      id: '1_2',
      Component: SubTab2,
    },
    {
      label: `1.3 Στοιχεία Πραγματικών Δικαιούχων`,
      id: '1_3',
      Component: SubTab3,
    }
  ].filter(item => item);
};
